<template>
  <v-main>
    <div style="height: 100%">
      <router-view/>
      <Loading></Loading>
      <Notifications></Notifications>
    </div>
  </v-main>
</template>

<script>
import Loading from "@/components/utils/Loading";
import Notifications from "@/components/utils/Notifications";

export default {
  name: "Default",
  components: {Notifications, Loading}
}
</script>

<style scoped>

</style>